import {CerbaCookieService, NotificationService} from "@digicerba/common";
import {PlanifierAlerteModal} from "./../../planifier-alerte-modal/planifier-alerte.modal";
import {StatutDossierEnums} from "@common/enum/StatutDossier.enum";
import {HprimFaxDialog} from "@common/utils/dialog/dialog-hprim-fax.component";
import {AsiDialogService} from "@asi-ngtools/lib";
import {
  DossierDto,
  HprimFaxDto,
  HprimFaxMedecin,
  IDossierWebServiceClient,
  ILaboratoireWebServiceClient,
  LigneDossierDto,
  ICorrespondantWebServiceClient, CorrespondantDto, FileProperties
} from "@resources/resources";
import {Component, Input} from "@angular/core";
import {TagsDonneesManquantes} from "@common/constants/TagsDonneesManquantes";
import {DonneesManquantesComponent} from "@utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component";
import {TranslateService} from "@ngx-translate/core";
import {EtatEnums} from "@common/enum/Etat.enum";


@Component({
  selector: 'action-detail-resultat',
  templateUrl: './action-detail-resultat.component.html'
})
export class ActionDetailServeurResultatsComponent {

  @Input() dossier: DossierDto;
  @Input() hprimEnabled: Boolean;
  @Input() reemissionEnabled: Boolean;

  tags: string[] = [];
  correspondants: CorrespondantDto[];
  fileProperties: FileProperties;


  constructor(private laboratoireWebService: ILaboratoireWebServiceClient,
              private asiDialogService: AsiDialogService,
              private dossierWebService: IDossierWebServiceClient,
              private translateService: TranslateService,
              private notificationService: NotificationService,
              private correspondantWebServiceClient: ICorrespondantWebServiceClient,
              private dossierClient: IDossierWebServiceClient,
              private cookieService: CerbaCookieService
  ) {



    if (this.correspondantWebServiceClient != null) {

      this.correspondantWebServiceClient.getCorrespondants().subscribe((arg) =>{
        if(arg){
          this.correspondants =arg;
        }
      },error => {
        console.log('erreur lors du chargement des correspondants');
        this.correspondants = null;
      });
    }

    this.dossierWebService.getFileProperties().subscribe(fileProperties => {
      this.fileProperties = fileProperties;
    });
  }


  openContactPage(){
    // Construction directe vers le nouveau module support (URL resolue selon l environnement).
    // On envoie uniquement l identifiant fonctionnel du dossier (et non l id technique).
    let supportBaseUrl = this.cookieService.getSupportBaseUrl(window.location.hostname);
    let contactUrl: string = supportBaseUrl + "/contact/" + this.dossier.identifiant;
    window.location.href = contactUrl;
  }

  envoiParMail() {
    this.dossierWebService.mailDossier(this.dossier.id).subscribe(() => {
      this.notificationService.showSuccessNotification("ACTION.mail_envoye");
    }, () => {
      this.notificationService.showErrorNotification("ACTION.mail_erreur");
    });
  }

  openHprimDialogUn() {
    let dossierRappel = new HprimFaxMedecin();
    dossierRappel.hprimFaxDto = new HprimFaxDto();

    let identifiants = new Array<string>();
    identifiants.push(this.dossier.identifiantLabo);
    this.laboratoireWebService.findByIdentifiants(identifiants).subscribe(logins => {

      dossierRappel.hprimFaxDto.numDossier = this.dossier.identifiant;
      if (logins[0] != null) {
        dossierRappel.hprimFaxDto.numCorrespondant = logins[0].login;
        dossierRappel.hprimFaxDto.numFax = logins[0].fax;
      }

      dossierRappel.hasMedecin = this.dossier.identifiantMed1 != null && this.dossier.identifiantMed1.trim().length > 0;
      this.openHprimDialog([dossierRappel]);
    });
  }

  openHprimDialog(dossiers: Array<HprimFaxMedecin>) {
    let asiDialog = this.asiDialogService.fromComponent(HprimFaxDialog, null);
    asiDialog.getComponent().dossiers = dossiers;
  }

  openAlerteDialog() {
    let alerteDialog = this.asiDialogService.fromComponent(PlanifierAlerteModal, null);
    let result = new LigneDossierDto();
    result.identifiant = this.dossier.identifiant;
    alerteDialog.getComponent().dossiers = [result];
  }

  isTermine(): boolean {
    return this.dossier.statutDossier == StatutDossierEnums.TERMINE.value();
  }

  isComplet(): boolean {
    return this.dossier.statutDossier == StatutDossierEnums.VALIDE_COMPLET.value() || this.isTermine();
  }

  isHprimActive() {
    if (this.hprimEnabled) {
      return this.hprimEnabled;
    } else {
      return false;
    }
  }

  public isReemissionEnabled(): Boolean {
    if (this.reemissionEnabled) {
      return this.reemissionEnabled;
    } else {
      return false;
    }
  }

  getCorrespondantTags() : string[] {
    let tags : string[] = null;

    if(this.correspondants) {
      for (let correspondant of this.correspondants) {
        if (correspondant.code == this.dossier.identifiantLabo) {
          tags = correspondant.tags;
          break;
        }
      }
    }
    return tags;
  }



  hasAccesDonneesManquantes() {
    let tags = this.getCorrespondantTags();
    if(tags != null){
      return tags.includes(TagsDonneesManquantes.FEL_CONTRIB) || tags.includes(TagsDonneesManquantes.FEL_GEST);
    }
    return false;
  }

  hasDonneesManquantes() {
    return this.dossier.nbDonneeManquante != null && this.dossier.nbDonneeManquante > 0;
  }

  hasDonneesManquantesEtAcces() {
    return this.hasAccesDonneesManquantes() && this.hasDonneesManquantes();
  }

  getDisplayIdentity(nom: String, prenom: String, nomJF: String) {
    let identity = "";
    if (nom != null && prenom != null) {
      identity = prenom + " " + nom;
      if (nomJF != null && nomJF != "") {
        identity += this.translateService.instant("PAGE.SERVEUR-RESULTATS.neeLe");
        identity += nomJF;
      }
    }
    return identity;
  }

  getDisplayIdentityPdf(nom: String, nomJF: String) {
    let identity = "";
    if (nom != null) {
      identity = " " + nom;
      if (nomJF != null && nomJF != "") {
        identity += this.translateService.instant("PAGE.DOSSIERS_BLOQUES.neeLe");
        identity += nomJF;
      }
    }
    return identity;
  }

  openDialogDonneesManquantes() {
    console.log(this.dossier);
    let asiDialog = this.asiDialogService.fromComponent(DonneesManquantesComponent, null);
    asiDialog.getComponent().numeroDossier = this.dossier.identifiant;
    asiDialog.getComponent().prenomNom = this.getDisplayIdentity(this.dossier.nomPatient, this.dossier.prenomPatient, this.dossier.nomJeuneFillePatient);
    asiDialog.getComponent().dateDeNaissance = this.dossier.dateNaissancePatient;
    asiDialog.getComponent().nom = this.getDisplayIdentityPdf(this.dossier.nomPatient, this.dossier.nomJeuneFillePatient);
    asiDialog.getComponent().prenom = this.dossier.prenomPatient
    asiDialog.getComponent().status = EtatEnums.EN_COURS;
    asiDialog.getComponent().tab = 'RESULTATS';
    asiDialog.getComponent().fileProperties = this.fileProperties;

    asiDialog.onDialogClose().subscribe((total: string) => {
      this.dossierClient.findById(this.dossier.id).subscribe(res => {
        this.dossier = res;
      });
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/action/action-detail-resultat.component.ts